/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import $ from "jquery";

require('../bootstrap');
require('../plugins');

import Vue from 'vue';
import store from './store'
import {vMask} from "./directives/inputMask";

window.Vue = require('vue');

// Vue Localization ----------------------------------------------------------
import translations from "../../assets/js/translations"
const lang = new Lang({
    messages: translations,
    fallback: 'en'
});
Lang.prototype._parseStringKey = function(key, locale) {
    if (typeof key !== 'string' || typeof locale !== 'string') {
        return null;
    }
    return {
        source: locale + '.strings',
        sourceFallback: this.getFallback() + '.strings',
        entries: [key]
    };
};
Lang.prototype._getMessage = function(originalKey, locale) {
    locale = locale || this.getLocale();

    let key = this._parseKey(originalKey, locale);
    let stringKey = this._parseStringKey(originalKey, locale);

    // Ensure message source exists.
    if (this.messages[key.source] === undefined && this.messages[key.sourceFallback] === undefined && this.messages[stringKey.source] === undefined && this.messages[stringKey.sourceFallback] === undefined) {
        return null;
    }
    // Get message from default locale.
    let message = this.messages[key.source];
    let entries = []
    if (message){
        entries = key.entries.slice();
    }
    else {
        message = this.messages[stringKey.source];
        entries = stringKey.entries.slice();
    }
    let subKey = entries.join('.');
    message = message !== undefined ? this._getValueInKey(message, subKey) : undefined;

    // Get message from fallback locale.
    if (typeof message !== 'string' && this.messages[key.sourceFallback]) {
        message = this.messages[key.sourceFallback];
        entries = key.entries.slice();
        subKey = '';
        while (entries.length && message !== undefined) {
            subKey = !subKey ? entries.shift() : subKey.concat('.', entries.shift());
            if (message[subKey]) {
                message = message[subKey]
                subKey = '';
            }
        }
    }
    if (typeof message !== 'string' && this.messages[stringKey.sourceFallback]) {
        message = this.messages[key.sourceFallback];
        entries = stringKey.entries.slice();
        let subKey = entries.join('.');
        message = message !== undefined ? this._getValueInKey(message, subKey) : undefined;
    }

    if (typeof message !== 'string') {
        return null;
    }

    return message;
};
window.trans = (...args) => {
    return lang.get(...args)
}
Vue.filter('trans', (...args) => {
    return lang.get(...args)
})
Vue.prototype.trans = (...args) => {
    return lang.get(...args)
}
Vue.filter('formatNumber', function (value) {
    let locale = lang.getLocale()
    if (!value) return '0';
    let formattedNumber = new Intl.NumberFormat(locale + '-' + locale.toUpperCase()).format(value)

    if (locale === 'ua') {
        formattedNumber = new Intl.NumberFormat('ru' + '-' + locale.toUpperCase()).format(value)
    }

    return formattedNumber
})
// Vue Localization ----------------------------------------------------------

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component('catalog-list-properties', require('./components/catalog/CatalogListProperties.vue').default);
Vue.component('catalog-list-pagination', require('./components/catalog/CatalogListPagination.vue').default);
Vue.component('properties-page-filter', require('./components/filtration/PropertiesPageFilter.vue').default);
Vue.component('main-page-filter', require('./components/filtration/MainPageFilter.vue').default);
Vue.component('popup-filter', require('./components/filtration/PopupFilter.vue').default);
Vue.component('catalog-complex-card-wrapper', require('./components/catalog/CatalogComplexCardWrapper.vue').default);
Vue.component('catalog-complex-card', require('./components/catalog/CatalogComplexCard.vue').default);
Vue.component('catalog-property-card', require('./components/catalog/CatalogPropertyCard.vue').default);
Vue.component('catalog-list-favorites', require('./components/catalog/CatalogListFavorites.vue').default);
Vue.component('complex-slider-wrapper', require('./components/swiper/ComplexSliderWrapper.vue').default);
Vue.component('complex-slider', require('./components/swiper/ComplexSlider.vue').default);
Vue.component('complex-slider-lazy', require('./components/swiper/ComplexSliderLazy.vue').default);
Vue.component('similar-properties-sliders-wrapper', require('./components/swiper/SimilarPropertiesSlidersWrapper.vue').default);
Vue.component('property-slider', require('./components/swiper/PropertySlider.vue').default);
Vue.component('images-gallery', require('./components/gallery/ImagesGallery.vue').default);
Vue.component('go-to-properties-button', require('./components/buttons/GoToPropertiesButton.vue').default);
Vue.component('go-to-complexes-button', require('./components/buttons/GoToComplexesButton.vue').default);
Vue.component('favorite-button', require('./components/favorites/FavoriteButton.vue').default);
Vue.component('favorites-link', require('./components/favorites/FavoritesLink.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.directive('mask', vMask())

const app = new Vue({
    store,
    el: '#app',
    beforeMount () {
        this.$store.dispatch('favorites/index');
        this.$store.dispatch('filtration/extractFromLocalStorageToState');
        this.$store.dispatch('filtration/convertSelectedPrices');
    },
    data: {
        baseUrl: window.baseUrl,
        currentCurrency: window.currentCurrency
    }
});

export default app;

//====================================================================================================================
export function uniqArray(array) {
    return array.filter(function (item, index, self) {
        return self.indexOf(item) === index;
    });
}

//====================================================================================================================
class DynamicAdapt {
    constructor(type) {
        this.type = type
    }
    init() {
        // масив об'єктів
        this.оbjects = []
        this.daClassname = '_dynamic_adapt_'
        // масив DOM-елементів
        this.nodes = [...document.querySelectorAll('[data-da]')]

        // наповнення оbjects об'єктами
        this.nodes.forEach((node) => {
            const data = node.dataset.da.trim()
            const dataArray = data.split(',')
            const оbject = {}
            оbject.element = node
            оbject.parent = node.parentNode
            оbject.destination = document.querySelector(`${dataArray[0].trim()}`)
            оbject.breakpoint = dataArray[1] ? dataArray[1].trim() : '767'
            оbject.place = dataArray[2] ? dataArray[2].trim() : 'last'
            оbject.index = this.indexInParent(оbject.parent, оbject.element)
            this.оbjects.push(оbject)
        })

        this.arraySort(this.оbjects)

        this.mediaQueries = this.оbjects
            .map(({ breakpoint }) => `(${this.type}-width: ${breakpoint}px),${breakpoint}`)
            .filter((item, index, self) => self.indexOf(item) === index)

        this.mediaQueries.forEach((media) => {
            const mediaSplit = media.split(',')
            const matchMedia = window.matchMedia(mediaSplit[0])
            const mediaBreakpoint = mediaSplit[1]

            const оbjectsFilter = this.оbjects.filter(({ breakpoint }) => breakpoint === mediaBreakpoint)
            matchMedia.addEventListener('change', () => {
                this.mediaHandler(matchMedia, оbjectsFilter)
            })
            this.mediaHandler(matchMedia, оbjectsFilter)
        })
    }

    mediaHandler(matchMedia, оbjects) {
        if (matchMedia.matches) {
            оbjects.forEach((оbject) => {
                // оbject.index = this.indexInParent(оbject.parent, оbject.element);
                this.moveTo(оbject.place, оbject.element, оbject.destination)
            })
        } else {
            оbjects.forEach(({ parent, element, index }) => {
                if (element.classList.contains(this.daClassname)) {
                    this.moveBack(parent, element, index)
                }
            })
        }
    }

    moveTo(place, element, destination) {
        element.classList.add(this.daClassname)
        if (place === 'last' || place >= destination.children.length) {
            destination.append(element)
            return
        }
        if (place === 'first') {
            destination.prepend(element)
            return
        }
        destination.children[place].before(element)
    }

    moveBack(parent, element, index) {
        element.classList.remove(this.daClassname)
        if (parent.children[index] !== undefined) {
            parent.children[index].before(element)
        } else {
            parent.append(element)
        }
    }

    indexInParent(parent, element) {
        return [...parent.children].indexOf(element)
    }

    arraySort(arr) {
        if (this.type === 'min') {
            arr.sort((a, b) => {
                if (a.breakpoint === b.breakpoint) {
                    if (a.place === b.place) {
                        return 0
                    }
                    if (a.place === 'first' || b.place === 'last') {
                        return -1
                    }
                    if (a.place === 'last' || b.place === 'first') {
                        return 1
                    }
                    return 0
                }
                return a.breakpoint - b.breakpoint
            })
        } else {
            arr.sort((a, b) => {
                if (a.breakpoint === b.breakpoint) {
                    if (a.place === b.place) {
                        return 0
                    }
                    if (a.place === 'first' || b.place === 'last') {
                        return 1
                    }
                    if (a.place === 'last' || b.place === 'first') {
                        return -1
                    }
                    return 0
                }
                return b.breakpoint - a.breakpoint
            })
            return
        }
    }
}

const da = new DynamicAdapt("min");
da.init();

// Модуль роботи з меню (бургер) ======================================================================================
let bodyLockStatus = true;
let bodyUnlock = (delay = 500) => {
    let body = document.querySelector("body");
    if (bodyLockStatus) {
        let lock_padding = document.querySelectorAll("[data-lp]");
        setTimeout(() => {
            for (let index = 0; index < lock_padding.length; index++) {
                const el = lock_padding[index];
                el.style.paddingRight = '0px';
            }
            body.style.paddingRight = '0px';
            document.documentElement.classList.remove("lock");
        }, delay);
        bodyLockStatus = false;
        setTimeout(function () {
            bodyLockStatus = true;
        }, delay);
    }
}
let bodyLock = (delay = 500) => {
    let body = document.querySelector("body");
    if (bodyLockStatus) {
        let lock_padding = document.querySelectorAll("[data-lp]");
        for (let index = 0; index < lock_padding.length; index++) {
            const el = lock_padding[index];
            el.style.paddingRight = window.innerWidth - document.querySelector('.wrapper').offsetWidth + 'px';
        }
        body.style.paddingRight = window.innerWidth - document.querySelector('.wrapper').offsetWidth + 'px';
        document.documentElement.classList.add("lock");

        bodyLockStatus = false;
        setTimeout(function () {
            bodyLockStatus = true;
        }, delay);
    }
}
let bodyLockToggle = (delay = 500) => {
    if (document.documentElement.classList.contains('lock')) {
        bodyUnlock(delay);
    } else {
        bodyLock(delay);
    }
}
function menuInit() {
    if (document.querySelector(".icon-menu")) {
        document.addEventListener("click", function (e) {
            if (bodyLockStatus && e.target.closest('.icon-menu')) {
                bodyLockToggle();
                document.documentElement.classList.toggle("menu-open");
            }
        });
    }
}

function dataMediaQueries(array, dataSetValue) {
    // Отримання об'єктів з медіа-запитами
    const media = Array.from(array).filter(function (item, index, self) {
        if (item.dataset[dataSetValue]) {
            return item.dataset[dataSetValue].split(",")[0];
        }
    });

    if (media.length) {
        const breakpointsArray = [];
        media.forEach(item => {
            const params = item.dataset[dataSetValue];
            const breakpoint = {};
            const paramsArray = params.split(",");
            breakpoint.value = paramsArray[0];
            breakpoint.type = paramsArray[1] ? paramsArray[1].trim() : "max";
            breakpoint.item = item;
            breakpointsArray.push(breakpoint);
        });
        // Отримуємо унікальні брейкпоінти
        let mdQueries = breakpointsArray.map(function (item) {
            return '(' + item.type + "-width: " + item.value + "px)," + item.value + ',' + item.type;
        });
        mdQueries = uniqArray(mdQueries);
        const mdQueriesArray = [];

        if (mdQueries.length) {
            // Працюємо з кожним брейкпоінтом
            mdQueries.forEach(breakpoint => {
                const paramsArray = breakpoint.split(",");
                const mediaBreakpoint = paramsArray[1];
                const mediaType = paramsArray[2];
                const matchMedia = window.matchMedia(paramsArray[0]);
                // Об'єкти з потрібними умовами
                const itemsArray = breakpointsArray.filter(function (item) {
                    if (item.value === mediaBreakpoint && item.type === mediaType) {
                        return true;
                    }
                });
                mdQueriesArray.push({
                    itemsArray,
                    matchMedia
                })
            });
            return mdQueriesArray;
        }
    }
}

function spollers() {
    const spollersArray = document.querySelectorAll("[data-spollers]");
    if (spollersArray.length > 0) {
        document.addEventListener("click", setSpollerAction);
        const spollersRegular = Array.from(spollersArray).filter((function(item, index, self) {
            return !item.dataset.spollers.split(",")[0];
        }));
        if (spollersRegular.length) initSpollers(spollersRegular);
        let mdQueriesArray = dataMediaQueries(spollersArray, "spollers");
        if (mdQueriesArray && mdQueriesArray.length) mdQueriesArray.forEach((mdQueriesItem => {
            mdQueriesItem.matchMedia.addEventListener("change", (function() {
                initSpollers(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
            }));
            initSpollers(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
        }));
        function initSpollers(spollersArray, matchMedia = false) {
            spollersArray.forEach((spollersBlock => {
                spollersBlock = matchMedia ? spollersBlock.item : spollersBlock;
                if (matchMedia.matches || !matchMedia) {
                    spollersBlock.classList.add("_spoller-init");
                    initSpollerBody(spollersBlock);
                } else {
                    spollersBlock.classList.remove("_spoller-init");
                    initSpollerBody(spollersBlock, false);
                }
            }));
        }
        function initSpollerBody(spollersBlock, hideSpollerBody = true) {
            let spollerItems = spollersBlock.querySelectorAll("details");
            if (spollerItems.length) spollerItems.forEach((spollerItem => {
                let spollerTitle = spollerItem.querySelector("summary");
                if (hideSpollerBody) {
                    spollerTitle.removeAttribute("tabindex");
                    if (!spollerItem.hasAttribute("data-open")) {
                        spollerItem.open = false;
                        spollerTitle.nextElementSibling.hidden = true;
                    } else {
                        spollerTitle.classList.add("_spoller-active");
                        spollerItem.open = true;
                    }
                } else {
                    spollerTitle.setAttribute("tabindex", "-1");
                    spollerTitle.classList.remove("_spoller-active");
                    spollerItem.open = true;
                    spollerTitle.nextElementSibling.hidden = false;
                }
            }));
        }
        function setSpollerAction(e) {
            const el = e.target;
            if (el.closest("summary") && el.closest("[data-spollers]")) {
                e.preventDefault();
                if (el.closest("[data-spollers]").classList.contains("_spoller-init")) {
                    const spollerTitle = el.closest("summary");
                    const spollerBlock = spollerTitle.closest("details");
                    const spollersBlock = spollerTitle.closest("[data-spollers]");
                    const oneSpoller = spollersBlock.hasAttribute("data-one-spoller");
                    const scrollSpoller = spollerBlock.hasAttribute("data-spoller-scroll");
                    const spollerSpeed = spollersBlock.dataset.spollersSpeed ? parseInt(spollersBlock.dataset.spollersSpeed) : 500;
                    if (!spollersBlock.querySelectorAll("._slide").length) {
                        if (oneSpoller && !spollerBlock.open) hideSpollersBody(spollersBlock);
                        !spollerBlock.open ? spollerBlock.open = true : setTimeout((() => {
                            spollerBlock.open = false;
                        }), spollerSpeed);
                        spollerTitle.classList.toggle("_spoller-active");
                        _slideToggle(spollerTitle.nextElementSibling, spollerSpeed);
                        if (scrollSpoller && spollerTitle.classList.contains("_spoller-active")) {
                            const scrollSpollerValue = spollerBlock.dataset.spollerScroll;
                            const scrollSpollerOffset = +scrollSpollerValue ? +scrollSpollerValue : 0;
                            const scrollSpollerNoHeader = spollerBlock.hasAttribute("data-spoller-scroll-noheader") ? document.querySelector(".header").offsetHeight : 0;
                            window.scrollTo({
                                top: spollerBlock.offsetTop - (scrollSpollerOffset + scrollSpollerNoHeader),
                                behavior: "smooth"
                            });
                        }
                    }
                }
            }
            if (!el.closest("[data-spollers]")) {
                const spollersClose = document.querySelectorAll("[data-spoller-close]");
                if (spollersClose.length) spollersClose.forEach((spollerClose => {
                    const spollersBlock = spollerClose.closest("[data-spollers]");
                    const spollerCloseBlock = spollerClose.parentNode;
                    if (spollersBlock.classList.contains("_spoller-init")) {
                        const spollerSpeed = spollersBlock.dataset.spollersSpeed ? parseInt(spollersBlock.dataset.spollersSpeed) : 500;
                        spollerClose.classList.remove("_spoller-active");
                        _slideUp(spollerClose.nextElementSibling, spollerSpeed);
                        setTimeout((() => {
                            spollerCloseBlock.open = false;
                        }), spollerSpeed);
                    }
                }));
            }
        }
        function hideSpollersBody(spollersBlock) {
            const spollerActiveBlock = spollersBlock.querySelector("details[open]");
            if (spollerActiveBlock && !spollersBlock.querySelectorAll("._slide").length) {
                const spollerActiveTitle = spollerActiveBlock.querySelector("summary");
                const spollerSpeed = spollersBlock.dataset.spollersSpeed ? parseInt(spollersBlock.dataset.spollersSpeed) : 500;
                spollerActiveTitle.classList.remove("_spoller-active");
                _slideUp(spollerActiveTitle.nextElementSibling, spollerSpeed);
                setTimeout((() => {
                    spollerActiveBlock.open = false;
                }), spollerSpeed);
            }
        }
    }
}
spollers();

function tabs() {
    const tabs = document.querySelectorAll('[data-tabs]');
    let tabsActiveHash = [];

    function getHash() {
        if (location.hash) { return location.hash.replace('#', ''); }
    }

    if (tabs.length > 0) {
        const hash = getHash();
        if (hash && hash.startsWith('tab-')) {
            tabsActiveHash = hash.replace('tab-', '').split('-');
        }
        tabs.forEach((tabsBlock, index) => {
            tabsBlock.classList.add('_tab-init');
            tabsBlock.setAttribute('data-tabs-index', index);
            tabsBlock.addEventListener("click", setTabsAction);
            initTabs(tabsBlock);
        });

        // Отримання слойлерів з медіа-запитами
        let mdQueriesArray = dataMediaQueries(tabs, "tabs");
        if (mdQueriesArray && mdQueriesArray.length) {
            mdQueriesArray.forEach(mdQueriesItem => {
                // Подія
                mdQueriesItem.matchMedia.addEventListener("change", function () {
                    setTitlePosition(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
                });
                setTitlePosition(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
            });
        }
    }
    // Встановлення позицій заголовків
    function setTitlePosition(tabsMediaArray, matchMedia) {
        tabsMediaArray.forEach(tabsMediaItem => {
            tabsMediaItem = tabsMediaItem.item;
            let tabsTitles = tabsMediaItem.querySelector('[data-tabs-titles]');
            let tabsTitleItems = tabsMediaItem.querySelectorAll('[data-tabs-title]');
            let tabsContent = tabsMediaItem.querySelector('[data-tabs-body]');
            let tabsContentItems = tabsMediaItem.querySelectorAll('[data-tabs-item]');
            tabsTitleItems = Array.from(tabsTitleItems).filter(item => item.closest('[data-tabs]') === tabsMediaItem);
            tabsContentItems = Array.from(tabsContentItems).filter(item => item.closest('[data-tabs]') === tabsMediaItem);
            tabsContentItems.forEach((tabsContentItem, index) => {
                if (matchMedia.matches) {
                    tabsContent.append(tabsTitleItems[index]);
                    tabsContent.append(tabsContentItem);
                    tabsMediaItem.classList.add('_tab-spoiler');
                } else {
                    tabsTitles.append(tabsTitleItems[index]);
                    tabsMediaItem.classList.remove('_tab-spoiler');
                }
            });
        });
    }
    // Робота з контентом
    function initTabs(tabsBlock) {
        let tabsTitles = tabsBlock.querySelectorAll('[data-tabs-titles]>*');
        let tabsContent = tabsBlock.querySelectorAll('[data-tabs-body]>*');
        const tabsBlockIndex = tabsBlock.dataset.tabsIndex;
        const tabsActiveHashBlock = tabsActiveHash[0] == tabsBlockIndex;

        if (tabsActiveHashBlock) {
            const tabsActiveTitle = tabsBlock.querySelector('[data-tabs-titles]>._tab-active');
            tabsActiveTitle ? tabsActiveTitle.classList.remove('_tab-active') : null;
        }
        if (tabsContent.length) {
            tabsContent = Array.from(tabsContent).filter(item => item.closest('[data-tabs]') === tabsBlock);
            tabsTitles = Array.from(tabsTitles).filter(item => item.closest('[data-tabs]') === tabsBlock);
            tabsContent.forEach((tabsContentItem, index) => {
                tabsTitles[index].setAttribute('data-tabs-title', '');
                tabsContentItem.setAttribute('data-tabs-item', '');

                if (tabsActiveHashBlock && index == tabsActiveHash[1]) {
                    tabsTitles[index].classList.add('_tab-active');
                }
                tabsContentItem.hidden = !tabsTitles[index].classList.contains('_tab-active');
            });
        }
    }
    function setTabsStatus(tabsBlock) {
        let tabsTitles = tabsBlock.querySelectorAll('[data-tabs-title]');
        let tabsContent = tabsBlock.querySelectorAll('[data-tabs-item]');
        const tabsBlockIndex = tabsBlock.dataset.tabsIndex;
        function isTabsAnamate(tabsBlock) {
            if (tabsBlock.hasAttribute('data-tabs-animate')) {
                return tabsBlock.dataset.tabsAnimate > 0 ? Number(tabsBlock.dataset.tabsAnimate) : 500;
            }
        }
        const tabsBlockAnimate = isTabsAnamate(tabsBlock);
        if (tabsContent.length > 0) {
            const isHash = tabsBlock.hasAttribute('data-tabs-hash');
            tabsContent = Array.from(tabsContent).filter(item => item.closest('[data-tabs]') === tabsBlock);
            tabsTitles = Array.from(tabsTitles).filter(item => item.closest('[data-tabs]') === tabsBlock);
            tabsContent.forEach((tabsContentItem, index) => {
                if (tabsTitles[index].classList.contains('_tab-active')) {
                    if (tabsBlockAnimate) {
                        _slideDown(tabsContentItem, tabsBlockAnimate);
                    } else {
                        tabsContentItem.hidden = false;
                    }
                    if (isHash && !tabsContentItem.closest('.popup')) {
                        setHash(`tab-${tabsBlockIndex}-${index}`);
                    }
                } else {
                    if (tabsBlockAnimate) {
                        _slideUp(tabsContentItem, tabsBlockAnimate);
                    } else {
                        tabsContentItem.hidden = true;
                    }
                }
            });
        }
    }
    function setTabsAction(e) {
        const el = e.target;
        if (el.closest('[data-tabs-title]')) {
            const tabTitle = el.closest('[data-tabs-title]');
            const tabsBlock = tabTitle.closest('[data-tabs]');
            if (!tabTitle.classList.contains('_tab-active') && !tabsBlock.querySelector('._slide')) {
                let tabActiveTitle = tabsBlock.querySelectorAll('[data-tabs-title]._tab-active');
                tabActiveTitle.length ? tabActiveTitle = Array.from(tabActiveTitle).filter(item => item.closest('[data-tabs]') === tabsBlock) : null;
                tabActiveTitle.length ? tabActiveTitle[0].classList.remove('_tab-active') : null;
                tabTitle.classList.add('_tab-active');
                setTabsStatus(tabsBlock);
            }
            e.preventDefault();
        }
    }
}

tabs()

// Допоміжні модулі плавного розкриття та закриття об'єкта ===========================================================
let _slideUp = (target, duration = 500, showmore = 0) => {
    if (!target.classList.contains('_slide')) {
        target.classList.add('_slide');
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.height = `${target.offsetHeight}px`;
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = showmore ? `${showmore}px` : `0px`;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.hidden = !showmore ? true : false;
            !showmore ? target.style.removeProperty('height') : null;
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            !showmore ? target.style.removeProperty('overflow') : null;
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            target.classList.remove('_slide');
            // Створюємо подію
            document.dispatchEvent(new CustomEvent("slideUpDone", {
                detail: {
                    target: target
                }
            }));
        }, duration);
    }
}
let _slideDown = (target, duration = 500, showmore = 0) => {
    if (!target.classList.contains('_slide')) {
        target.classList.add('_slide');
        target.hidden = target.hidden ? false : null;
        showmore ? target.style.removeProperty('height') : null;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = showmore ? `${showmore}px` : `0px`;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            target.classList.remove('_slide');
            // Створюємо подію
            document.dispatchEvent(new CustomEvent("slideDownDone", {
                detail: {
                    target: target
                }
            }));
        }, duration);
    }
}
let _slideToggle = (target, duration = 500) => {
    if (target.hidden) {
        return _slideDown(target, duration);
    } else {
        return _slideUp(target, duration);
    }
}

// Модуль роботи зі спойлерами ========================================================================================
function spoilers() {
    const spoilersArray = document.querySelectorAll('[data-spollers]');
    if (spoilersArray.length > 0) {
        // Отримання звичайних слойлерів
        const spoilersRegular = Array.from(spoilersArray).filter(function (item, index, self) {
            return !item.dataset.spollers.split(",")[0];
        });
        // Ініціалізація звичайних слойлерів
        if (spoilersRegular.length) {
            initSpoilers(spoilersRegular);
        }
        // Отримання слойлерів з медіа-запитами
        let mdQueriesArray = dataMediaQueries(spoilersArray, "spoilers");
        if (mdQueriesArray && mdQueriesArray.length) {
            mdQueriesArray.forEach(mdQueriesItem => {
                // Подія
                mdQueriesItem.matchMedia.addEventListener("change", function () {
                    initSpoilers(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
                });
                initSpoilers(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
            });
        }
        // Ініціалізація
        function initSpoilers(spoilersArray, matchMedia = false) {
            spoilersArray.forEach(spoilersBlock => {
                spoilersBlock = matchMedia ? spoilersBlock.item : spoilersBlock;
                if (matchMedia.matches || !matchMedia) {
                    spoilersBlock.classList.add('_spoiler-init');
                    initSpoilerBody(spoilersBlock);
                    spoilersBlock.addEventListener("click", setSpoilerAction);
                } else {
                    spoilersBlock.classList.remove('_spoiler-init');
                    initSpoilerBody(spoilersBlock, false);
                    spoilersBlock.removeEventListener("click", setSpoilerAction);
                }
            });
        }
        // Робота з контентом
        function initSpoilerBody(spoilersBlock, hideSpoilerBody = true) {
            let spoilerTitles = spoilersBlock.querySelectorAll('[data-spoiler]');
            if (spoilerTitles.length) {
                spoilerTitles = Array.from(spoilerTitles).filter(item => item.closest('[data-spollers]') === spoilersBlock);
                spoilerTitles.forEach(spoilerTitle => {
                    if (hideSpoilerBody) {
                        spoilerTitle.removeAttribute('tabindex');
                        if (!spoilerTitle.classList.contains('_spoiler-active')) {
                            spoilerTitle.nextElementSibling.hidden = true;
                        }
                    } else {
                        spoilerTitle.setAttribute('tabindex', '-1');
                        spoilerTitle.nextElementSibling.hidden = false;
                    }
                });
            }
        }
        function setSpoilerAction(e) {
            const el = e.target;
            if (el.closest('[data-spoiler]')) {
                const spoilerTitle = el.closest('[data-spoiler]');
                const spoilersBlock = spoilerTitle.closest('[data-spollers]');
                const oneSpoiler = spoilersBlock.hasAttribute('data-one-spoiler');
                const spoilerSpeed = spoilersBlock.dataset.spoilersSpeed ? parseInt(spoilersBlock.dataset.spoilersSpeed) : 500;
                if (!spoilersBlock.querySelectorAll('._slide').length) {
                    if (oneSpoiler && !spoilerTitle.classList.contains('_spoiler-active')) {
                        hideSpoilersBody(spoilersBlock);
                    }
                    spoilerTitle.classList.toggle('_spoiler-active');
                    _slideToggle(spoilerTitle.nextElementSibling, spoilerSpeed);
                }
                e.preventDefault();
            }
        }
        function hideSpoilersBody(spoilersBlock) {
            const spoilerActiveTitle = spoilersBlock.querySelector('[data-spoiler]._spoiler-active');
            const spoilerSpeed = spoilersBlock.dataset.spoilersSpeed ? parseInt(spoilersBlock.dataset.spoilersSpeed) : 500;
            if (spoilerActiveTitle && !spoilersBlock.querySelectorAll('._slide').length) {
                spoilerActiveTitle.classList.remove('_spoiler-active');
                _slideUp(spoilerActiveTitle.nextElementSibling, spoilerSpeed);
            }
        }
        // Закриття при кліку поза спойлером
        const spoilersClose = document.querySelectorAll('[data-spoiler-close]');
        if (spoilersClose.length) {
            document.addEventListener("click", function (e) {
                const el = e.target;
                if (!el.closest('[data-spollers]')) {
                    spoilersClose.forEach(spoilerClose => {
                        const spoilersBlock = spoilerClose.closest('[data-spollers]');
                        if (spoilersBlock.classList.contains('_spoiler-init')) {
                            const spoilerSpeed = spoilersBlock.dataset.spoilersSpeed ? parseInt(spoilersBlock.dataset.spoilersSpeed) : 500;
                            spoilerClose.classList.remove('_spoiler-active');
                            _slideUp(spoilerClose.nextElementSibling, spoilerSpeed);
                        }
                    });
                }
            });
        }
    }
}

spoilers()

// Isotope ============================================================================================================

let window_width = window.innerWidth;

import Isotope from 'isotope-layout/js/isotope.js';

if (window_width && window_width > 1170) {
    const items = document.querySelector('[data-iso-items]');
    if (items) {
        const itemsGrid = new Isotope(items, {
            itemSelector: '[data-iso-item]',
            masonry: {
                columnWidth: '.category__card',
                gutter: 30,
                // horizontalOrder: true,
                // fitWidth: true,
            }
        });
    }
}
let catalog_isotope = document.querySelector('.catalog__spoilers');
let itemsGrid;

function initIsotope() {
    if (catalog_isotope && window.innerWidth >= 768) {
        itemsGrid = new Isotope(catalog_isotope, {
            itemSelector: '[data-iso-item]',
            masonry: {
                columnWidth: '.catalog-spoilers__item',
                gutter: 10,
            }
        });
    }
}
function destroyIsotope() {
    if (itemsGrid) {
        itemsGrid.destroy();
        itemsGrid = null;
    }
}

initIsotope();

window.addEventListener('resize', function () {
    if (window.innerWidth < 768) {
        destroyIsotope();
    } else {
        initIsotope();
    }
});

// Swiper =============================================================================================================
import "./scss/swiper.scss";
import Lang from "lang.js";
import {addLoadListenerToLazyLoadObjects, initSliders} from "./shareable/functions"

window.addEventListener("load", function (e) {
    initSliders();
});

document.addEventListener("DOMContentLoaded", function () {
    addLoadListenerToLazyLoadObjects();
});

function notificationPositioning(notification, appearanceTime, disappearanceTime) {
    if (notification) {
        setTimeout(function() {
            notification.style.top = "0";
        }, appearanceTime);

        setTimeout(function() {
            notification.style.top = "-100px";
        }, disappearanceTime);
    }
    return notification;
}

function showNotificationSuccess() {
    let notification = document.querySelector(".notification.notification--success");
    notificationPositioning(notification, 0, 10000);
}

function showNotificationFailed() {
    let notification = document.querySelector(".notification.notification--failed");
    notificationPositioning(notification, 0, 10000);
}

function showNotificationCopied(currentSelector) {
    let notification = currentSelector.prev(".notification.notification--copied")[0];
    if (notification) {
        setTimeout(function() {
            notification.style.opacity = 1;
        }, 1000);

        setTimeout(function() {
            notification.style.opacity = 0;
        }, 4000);
    }
}

function addButtonBasedOnContentHeight() {
    let contentHeight = $('.object-about__content').height();
    let threshold = 130;
    let maxHeight = 400;

    if (contentHeight > threshold) {
        $('[data-showmore-button="' + maxHeight + '"]').show();
    } else {
        $('[data-showmore-button="' + maxHeight + '"]').hide();
    }
}

function hideFakeTextarea(name) {
    const textarea = $('#' + name);

    textarea.focus(function() {
        $(this).parent().find('.fake-textarea').hide();
        textarea.removeClass('p-absolute')
    });
}

window.selectFilteredDistricts = function(districtsFilteredBy, inputsSelector) {
    districtsFilteredBy = districtsFilteredBy.map(function (district) {
        return 'area_' + district;
    });

    if ($(inputsSelector).not('#area_all').length === districtsFilteredBy.length) {
        $(inputsSelector).prop('checked', true);
    } else {
        $(inputsSelector).not('#area_all').each(function (i, checkbox) {
            if ($.inArray(checkbox.id, districtsFilteredBy) !== -1) {
                $(checkbox).prop('checked', true)
            }
        });
    }
}

window.popupInputsListener = function (inputsSelector, areaAllInputSelector) {
    $(inputsSelector).on('change', function (e) {
        if ($(inputsSelector + ':checked').not(areaAllInputSelector).length < $(inputsSelector).not(areaAllInputSelector).length) {
            $(areaAllInputSelector).prop('checked', false);
        } else {
            $(areaAllInputSelector).prop('checked', true);
        }
    })
};

document.addEventListener("DOMContentLoaded", function() {
    showNotificationSuccess();
    showNotificationFailed();
});

const slider = document.querySelector('.top-object-page__slider');
if(slider && slider.querySelector('.top-object__no-image-wrapper')) {
    slider.style.border = '1px solid #B5B6B8';
}

$(document).ready(function () {
    $('.form_consultation').on('submit', function (e) {
        e.preventDefault();

        let form = $(this);

        let modalForm = false;
        if (form.hasClass('modal_form')) {
            modalForm = true;
        }

        const feedbackSubmitButtons = form.find('.body-popup-form__button, .form-side-object__button, .actions-form-contacts__button');

        feedbackSubmitButtons.prop('disabled', true);
        feedbackSubmitButtons.text('...');

        $.ajax({
            url: form.attr('action'),
            method: 'POST',
            data: form.serialize(),
            success: function (response) {
                if (response.success) {
                    if (modalForm) {
                        sendEvent('key_modalform', {})
                    } else {
                        sendEvent('key_form', {})
                    }

                    let mes = response.message;
                    if (mes) {
                        $('.page').before(`<div class="notification notification--success">` + mes + `</div>`);
                    } else {
                        $('.page').before(`<div class="notification notification--success">${trans('Application submitted!')}</div>`);
                    }
                    form[0].reset();
                    feedbackSubmitButtons.text(trans('Send'));
                    form.find('.body-popup-form__inp-error').remove();
                    showNotificationSuccess();
                    form.find('.is-invalid').removeClass('is-invalid');
                    form.find('.invalid-feedback').remove();
                    feedbackSubmitButtons.prop('disabled', false);
                } else {
                    alert(trans('Something went wrong. Please try again.'))
                }
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    feedbackSubmitButtons.text(trans('Send'));
                    let errors = xhr.responseJSON.errors;

                    form.find('.body-popup-form__inp-error').remove();
                    $.each(errors, function (key, rules) {
                        let errorMessage = '';
                        $.each(Object.values(rules), function (rule, message) {
                            if (typeof message == 'object') {
                                $.each(Object.values(message), function (r, m) {
                                    errorMessage += m + '<br>';
                                });
                            } else {
                                errorMessage += message + '<br>';
                            }
                        });
                        if (key === 'accepted_policy') {
                            form.find(`[name="${key}"]`).before(`<div class="body-popup-form__inp-error">${errorMessage}</div>`);
                        } else {
                            if (form.find(`[name="${key}"]`).closest('.form-side-object__line').length) {
                                form.find(`[name="${key}"]`).closest('.form-side-object__line').after(`<div class="body-popup-form__inp-error">${errorMessage}</div>`);
                            } else {
                                form.find(`[name="${key}"]`).after(`<div class="body-popup-form__inp-error">${errorMessage}</div>`);
                            }
                        }
                    });
                    $('.page').before(`<div class="notification notification--failed">${trans('Please check the form for accuracy!')}</div>`)
                    showNotificationFailed();

                    feedbackSubmitButtons.prop('disabled', false);
                } else {
                    alert(trans('Something went wrong. Please try again.'))
                }
            },
        })
    });

    const consultationPopups = ['consultationTextarea', 'consultationTextareaMore', 'consultationTextareaVideo'];

    consultationPopups.forEach((popupName) => {
        hideFakeTextarea(popupName);
    })

    addButtonBasedOnContentHeight();

    $('.popup-select-area__reset').on('click', function (e) {
        $('.popup-select-area .checkbox__input').prop('checked', false)
        $('#area_all').prop('checked', true);
    })

    $('#area_all').on('change', function (e) {
        $('.popup-select-area .checkbox__input').prop('checked', this.checked)
    })

    $('.popup-select-area__submit').on('click', function (e) {
        e.preventDefault()

        let selectedDistricts = [];
        $('.popup-select-area .checkbox__input:checked').not('#area_all').each(function () {
            selectedDistricts.push($(this).attr('name'));
        });

        let commonComplexesUrl = '/complexes';
        if (selectedDistricts.length > 0) {
            if (selectedDistricts.length < $('.popup-select-area .checkbox__input').not('#area_all').length) {
                let queryString = $.param({districts: selectedDistricts});
                window.location.href = commonComplexesUrl + '?' + queryString;
            } else {
                window.location.href = commonComplexesUrl;
            }
        }
    });

    $('.images-top-object__share, .actions-images-popup__share, .lg-share').on('click', function (e) {
        let clickedEl = $(this);
        if (!navigator.clipboard) {
            const $temp = $("input");
            $("body").append($temp);
            $temp.val($(location).attr('href')).select();
            document.execCommand("copy");
            $temp.remove();

            showNotificationCopied(clickedEl);
        } else {
            let linkToCopy = $(location).attr('href');
            navigator.clipboard.writeText(linkToCopy).then(
                function () {
                    showNotificationCopied(clickedEl);
                })
                .catch(
                    function () {
                        console.log("couldn't copy a shareable link");
                    });
        }
    });
    $('.card-button').on('click', function (e) {
        e.stopPropagation();
    });

    $('#savePreferences').on('click', function (e) {
        window.localStorage.removeItem('filtration');
    });

    let blogScrollLoadMore = true;
    $(window).on("scroll", function () {
        if (blogScrollLoadMore && ($(window).scrollTop() + $(window).height() >= $(document).height() - 1000)) {
            blogScrollLoadMore = false;
            Livewire.emit('loadMore');
            setTimeout(() => blogScrollLoadMore = true, 3000);
        }
    });

    // Observer for lazy loading of images on property/complex details
    const detailsPageImagesPopup = document.querySelector('.popup-images');
    if (detailsPageImagesPopup) {
        const detailsPageImagesPopupObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    if (detailsPageImagesPopup.classList.contains('popup_show')) {
                        const images = detailsPageImagesPopup.querySelectorAll('img[data-src]');
                        images.forEach((img) => {
                            img.setAttribute('src', img.getAttribute('data-src'));
                            img.removeAttribute('data-src');
                        });
                    }
                }
            });
        });

        detailsPageImagesPopupObserver.observe(
            detailsPageImagesPopup,
            {attributes: true}
        );
    }
});

const sendEvent = (eventName, data) => {
    if (window.gtag) {
        gtag('event', eventName, data);
    }
}
window.sendEvent = sendEvent;
$(document).ready(function ($) {
    $('a[href^="tel:"]').on('click', function () {
        sendEvent("key_phone", {});
    });
    $('[data-popup=".popup-images"]').on('click', function () {
        sendEvent("key_gallery", {});
    })
});
